import React from 'react';
import { AreaChart, Area, XAxis, YAxis, Tooltip, CartesianGrid } from 'recharts';
import DashboardCard, {
    ChartBody,
    ChartEmpty,
    ChartPlot,
    ChartTooltip,
    CHART_MARGIN,
    chartTick,
} from './DashboardCard';

interface LeadsByPeriodChartProps {
    data: any[];
}

const LeadsByPeriodChart: React.FC<LeadsByPeriodChartProps> = ({ data }) => {
    return (
        <DashboardCard title="Negociações no período">
            {data.length === 0 ? (
                <ChartEmpty>Sem negociações neste período.</ChartEmpty>
            ) : (
                <ChartBody>
                    <ChartPlot>
                            <AreaChart data={data} margin={CHART_MARGIN}>
                                <defs>
                                    <linearGradient id="colorLeads" x1="0" y1="0" x2="0" y2="1">
                                        <stop offset="0%" stopColor="var(--color-primary)" stopOpacity={0.28} />
                                        <stop offset="100%" stopColor="var(--color-primary)" stopOpacity={0} />
                                    </linearGradient>
                                </defs>
                                <CartesianGrid
                                    stroke="var(--color-border-subtle)"
                                    vertical={false}
                                    strokeDasharray="0"
                                />
                                <XAxis
                                    dataKey="name"
                                    tick={chartTick}
                                    tickLine={false}
                                    axisLine={false}
                                    minTickGap={28}
                                    interval="preserveStartEnd"
                                    tickMargin={8}
                                    padding={{ left: 8, right: 16 }}
                                />
                                <YAxis
                                    tick={chartTick}
                                    tickLine={false}
                                    axisLine={false}
                                    allowDecimals={false}
                                    width={36}
                                    tickCount={4}
                                    tickMargin={4}
                                />
                                <Tooltip
                                    cursor={{ stroke: 'var(--color-border)', strokeWidth: 1 }}
                                    content={<ChartTooltip />}
                                />
                                <Area
                                    type="monotone"
                                    dataKey="Negociações"
                                    stroke="var(--color-primary)"
                                    strokeWidth={2}
                                    fillOpacity={1}
                                    fill="url(#colorLeads)"
                                    dot={false}
                                    activeDot={{
                                        r: 3.5,
                                        strokeWidth: 2,
                                        fill: 'var(--color-card)',
                                        stroke: 'var(--color-primary)',
                                    }}
                                />
                            </AreaChart>
                    </ChartPlot>
                </ChartBody>
            )}
        </DashboardCard>
    );
};

export default LeadsByPeriodChart;
